import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-aboutcompanycontainer',
  imports: [CommonModule,RouterModule],
  templateUrl: './aboutcompanycontainer.component.html',
  styleUrl: './aboutcompanycontainer.component.scss',
  standalone: true
})
export class AboutcompanycontainerComponent {

}
